import React, { FC } from 'react';

import { SeedsList } from 'src/components/property-settings/sections/seeds-list/SeedsList';
import { SETTINGS_SECTION_TYPES } from 'src/types/SettingsSectionTypes';

import { usePropertySettings } from '../context';
import { clearSectionError, setDraft } from '../state';

export const SeedsSectionModule: FC = () => {
	const {
		state: { draft, errors },
		dispatch,
		isListMode
	} = usePropertySettings();

	return (
		<SeedsList
			title={isListMode ? 'Urls list' : undefined}
			property={draft}
			setProperty={(p) => dispatch(setDraft(p))}
			propertyError={errors.find((e) => e.sectionId === SETTINGS_SECTION_TYPES.SEEDS)}
			removePropertyError={(sectionId) => dispatch(clearSectionError(sectionId))}
			isPropertyInListMode={isListMode}
		/>
	);
};
